import { FileText } from "lucide-react";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";

dayjs.extend(isToday);

interface DigestMetrics {
  touched_conversations?: number;
  source_messages?: number;
  urgent_count?: number;
  booking_count?: number;
  admin_count?: number;
  conversations?: number;
  urgent?: number;
  booking?: number;
  admin?: number;
}

interface ReopeningDigestThreadRowProps {
  digestId: string;
  windowEnd: string;
  metrics: DigestMetrics;
  isSelected: boolean;
  onClick: () => void;
}

/**
 * Pinned pseudo-thread row rendered at index 0 of the conversations list
 * when a non-hidden digest exists.
 */
export default function ReopeningDigestThreadRow({
  digestId: _digestId,
  windowEnd,
  metrics,
  isSelected,
  onClick,
}: ReopeningDigestThreadRowProps) {
  const remaining = metrics.conversations;
  const touched = remaining ?? metrics.touched_conversations ?? 0;
  const windowDate = dayjs(windowEnd);
  const dateLabel = windowDate.isToday()
    ? "Today"
    : windowDate.format("DD/MM/YYYY");

  const subtitle = remaining !== undefined
    ? touched === 0
      ? "No active conversations remaining"
      : touched === 1
      ? "1 active conversation from closure"
      : `${touched} active conversations from closure`
    : touched === 0
      ? "No conversations during closure"
      : touched === 1
      ? "1 conversation touched while closed"
      : `${touched} conversations touched while closed`;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full flex items-center gap-3 px-4 py-3 text-left transition hover:bg-teal-50/60
        ${isSelected ? "bg-teal-50 ring-1 ring-teal-200/70 border-l-2 border-teal-400" : "border-l-4 border-teal-300 bg-teal-50/30"}
      `}
    >
      {/* Icon replacing patient avatar */}
      <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 bg-teal-100 ring-1 ring-teal-200">
        <FileText className="w-4.5 h-4.5 text-teal-600" strokeWidth={1.5} />
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-teal-900 truncate">
            Morning digest
          </span>
          <span className="ml-auto text-[11px] text-teal-500 tabular-nums shrink-0">
            {dateLabel}
          </span>
        </div>
        <p className="text-xs text-teal-600 truncate">{subtitle}</p>
      </div>
    </button>
  );
}
